const PermissionType = Object.freeze({
  VIEW_METADATA: "VIEW_METADATA",
  VIEW_GEOMETRY: "VIEW_GEOMETRY",
  EDIT_METADATA: "EDIT_METADATA",
  EDIT_GEOMETRY: "EDIT_GEOMETRY"
});
export default PermissionType;